import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  Space,
  Card,
  Select,
  Row,
  Col,
  DatePicker,
  Button,
  Table,
  Tabs,
} from 'antd';
import { ImportOutlined } from '@ant-design/icons';
import { gql, useMutation, useLazyQuery } from '@apollo/client';
import moment from 'moment';

import Layout from '../Layout/index';
import ErrorBoundary from '../../components/Utils/ErrorBoundary';
import IncentivesSummaryReport from './IncentivesSummaryReport';
import AgencyManagerReport from './AgencyManagerReport';
import FESummaryReport from './FESummaryReport';

const { Option } = Select;
const { TabPane } = Tabs;

const Reports = ({ history, match }) => {
  const handleChange = () => {};

  return (
    <Layout title="Reports">
      <Tabs
        defaultActiveKey={
          typeof match.params !== 'undefined' &&
          typeof match.params.tab !== 'undefined'
            ? match.params.tab
            : 'incentives-summary-report'
        }
        type="editable-card"
        size="medium"
        key={
          typeof match.params !== 'undefined' &&
          typeof match.params.tab !== 'undefined'
            ? match.params.tab
            : 'incentives-summary-report'
        }
        className="expenseTab"
        hideAdd
        onChange={(key) => {
          history.push(`/reports/${key}`);
        }}
      >
        <TabPane
          tab={<span>Incentives Summary</span>}
          key="incentives-summary-report"
          closable={false}
        >
          <ErrorBoundary>
            <IncentivesSummaryReport gridId="incentives-summary-report" />
          </ErrorBoundary>
        </TabPane>
        <TabPane
          tab={<span>Agency Manager Report</span>}
          key="agency-manager-report"
          closable={false}
        >
          <ErrorBoundary>
            <AgencyManagerReport gridId="agency-manager-report" />
          </ErrorBoundary>
        </TabPane>
        {/* <TabPane
          tab={<span>FE Summary Report</span>}
          key="fe-summary-report"
          closable={false}
        >
          <ErrorBoundary>
            <FESummaryReport gridId="agency-manager-report" />
          </ErrorBoundary>
        </TabPane> */}
      </Tabs>
    </Layout>
  );
};

export default Reports;
